module.exports = __webpack_public_path__ + "static/media/FIG8-CAT5.ea56c56a.png";